import { render } from "./clothCard.vue?vue&type=template&id=81ce610c&scoped=true&ts=true"
import script from "./clothCard.vue?vue&type=script&lang=ts"
export * from "./clothCard.vue?vue&type=script&lang=ts"

import "./clothCard.vue?vue&type=style&index=0&id=81ce610c&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ldcloud\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81ce610c"]])

export default __exports__